import * as PIXI from "pixi.js";
import MyApplication from "../../../pixi/MyApplication";
import AssetsManager from "../../../pixi/AssetsManager";

/**
 * ScoreViewクラス
 */
class ScoreView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	VARS
  // ---------------------------------------------------------------------------------------------------------

  private _txtBox: PIXI.BitmapText;
  private _txtBox2: PIXI.BitmapText;

  private _m: PIXI.Sprite;
  private _m2: PIXI.Sprite;

  // ---------------------------------------------------------------------------------------------------------
  // --	ScoreView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    //アンチエイリアスをとる
    PIXI.Assets.get("FFF_ASTRO").pageTextures[0].baseTexture.scaleMode =
      PIXI.SCALE_MODES.NEAREST;

    this._txtBox = new PIXI.BitmapText("0", {
      fontName: "FFF Astro",
      fontSize: 16 * 4,
    });
    this._txtBox.anchor.set(1, 0);
    this._txtBox.x = -40;
    this.addChild(this._txtBox);

    this._txtBox2 = new PIXI.BitmapText("0", {
      fontName: "FFF Astro",
      fontSize: 16 * 4,
    });
    this._txtBox2.anchor.set(1, 0);
    this._txtBox2.x = -40 + 4;
    this._txtBox2.y = 4;
    this.addChildAt(this._txtBox2, 0);

    //m配置
    this._m = AssetsManager.instance.createSpriteByName("score_m.png");
    this._m.anchor.set(1, 0);
    this._m.scale.set(4);
    this._m.x = -12;
    this._m.y = 40;
    this.addChild(this._m);

    this._m2 = AssetsManager.instance.createSpriteByName("score_m.png");
    this._m2.anchor.set(1, 0);
    this._m2.scale.set(4);
    this._m2.x = -12 + 4;
    this._m2.y = 40 + 4;
    this.addChildAt(this._m2, 0);
  }

  update(score: number): void {
    this._txtBox.text = String(score);
    this._txtBox2.text = String(score);
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default ScoreView;
